import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  PieChart,
  Pie,
  Sector,
  Cell,
  ResponsiveContainer,
  Legend,
  Tooltip,
  LabelList,
} from "recharts";
import { useSelector, useDispatch } from "react-redux";
import {
  deleteTemporaryFilters,
  getL1SheetProperty,
  setFiltersToOtherSheets,
  getL2SheetProperty,
  setWorkbookProperty,
  getWorkbookProperty,
  updateLevel2Properties,
  removeLevel2Properties,
  setCommonFilters,
} from "../../../features/reduxworkbook/WorkbookSlice";
import { getColourSchemeByID } from "../../../Colors/ColorPalettes";
import { CustomTooltip } from "../Custom/CustomTooltipContent";
import { nanoid } from "@reduxjs/toolkit";
import {
  getSheetControls,
  setSheetControls,
} from "../../../features/reduxworkbook/WorkbookControllingSlice";
import { formatNumber } from "../Utils/FormatNumbers";
import { getNumbersAndTotals } from "../Utils/castToNumberAndTotals";
import { CalculateAction, handleClicked } from "../../actions/Action";
import { sortData } from "../Utils/SortData";

import { CustomLegend } from "../Custom/CustomLegendContent";
import { handleHeirarchy } from "../Utils/HandleHeirarchy";
import { adjustOpacity } from "../Utils/ChartsFunctions";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

const renderCustomActiveShape = (props) => {
  const {
    cx,
    cy,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
  } = props;
  console.log(percent);

  // const radius = outerRadius + 90 + labelOffset; // Increase distance from the pie chart

  console.log(innerRadius);

  // Extract the key from payload
  const payloadKey = Object.keys(payload).find(
    (key) =>
      key !== "payload" &&
      key !== "cx" &&
      key !== "cy" &&
      key !== "fill" &&
      key !== "className" &&
      key !== "stroke"
  );

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius + 10}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill} // Use highlightFill for both text and sector
        percent={`Rate ${(percent * 100).toFixed(2)}%`}
        style={{ outline: "none" }}
      />
    </g>
  );
};

const ReduxPieComp = ({
  Data = [],
  valueKeys = [],
  Sheetid,
  toolTipKeys,
  rowKeys = [],
  groupByKeys = [],
  sortProperties,
  isAnimataionOff,
  vizType,
  filters: filterArray,
  dataSourceID,
}) => {
  const { roles } = useAuth();
  console.log(roles);
  console.log(toolTipKeys);
  const navigate = useNavigate();

  let timer;
  const reduxActiveIndex = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "activeIndex" })
  );
  const reduxClickedCaption = useSelector(
    getSheetControls({ Sheetid: Sheetid, key: "clickedCaption" })
  );
  const [outerRadius, setOuterRadius] = useState(0);
  const [innerRadius, setInnerRadius] = useState(0);
  const [labelOffset, setLabelOffset] = useState(10); // Default offset value
  const [labelFontSize, setlabelFontSize] = useState(0);
  const [clickedCaption, setClickedCaption] = useState(
    (reduxClickedCaption !== undefined && reduxClickedCaption) || []
  );
  const [activeIndex, setActiveIndex] = useState(
    (reduxActiveIndex !== undefined && reduxActiveIndex) || []
  );
  const [hoverIndex, setHoverIndex] = useState();
  const [containerHeight, setContainerHeight] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const [clickTimeoutState, setClickTimeoutState] = useState(null);

  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const dispatchCommonFilters = (value, operation) => {
    console.log(value);
    dispatch(
      setCommonFilters({
        operation,
        value,
        Sheetid,
      })
    );
  };
  const sheetsArray = useSelector((state) =>
    getWorkbookProperty(state, "sheets")
  );

  const customizationObject = useSelector((state) =>
    getL1SheetProperty(state, Sheetid, "customization")
  );
  const SufixPrefix = { ...valueKeys.map((item) => item.numberFormat)[0] };

  const getOnClickProperties = useSelector((state) => {
    return getL2SheetProperty(state, Sheetid, "actions", "onClick");
  });
  console.log(getOnClickProperties);

  const getOnDoubleClickProperties = useSelector((state) =>
    getL2SheetProperty(state, Sheetid, "actions", "onDoubleClick")
  );
  console.log(getOnDoubleClickProperties);

  const hierarchy =
    useSelector((state) => getWorkbookProperty(state, "hierarchy")) || {};
  const workbookId =
    useSelector((state) => getWorkbookProperty(state, "_id")) || [];
  const workbookType =
    useSelector((state) => getWorkbookProperty(state, "type")) || [];
  console.log(customizationObject.labelFontSize);
  console.log(labelFontSize);

  const handleMouseEnter = (_, index) => {
    setHoverIndex(index);
  };
  const handleMouseLeave = () => {
    setHoverIndex(null);
  };
  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const containerWidthValue = containerRef.current.offsetWidth;
        const containerHeightValue = containerRef.current.offsetHeight; // Get container height
        // console.log(containerHeightValue);

        setContainerHeight(containerHeightValue);
        setContainerWidth(containerWidthValue);
        const maxRadius =
          Math.min(containerWidthValue, containerHeightValue) / 2 - 10;
        const dynamicLabelOffset = maxRadius * 0.1;
        const maxSize =
          Math.min(containerWidthValue, containerHeightValue) / 2 - 10;

        // Set outer and inner radius based on customizationObject and container size
        setOuterRadius(
          Math.min(customizationObject.outerRadius, maxRadius * 0.7)
        );
        setInnerRadius(
          Math.min(customizationObject.innerRadius, maxRadius * 0.5)
        );

        // Set dynamic label offset and font size
        setLabelOffset(dynamicLabelOffset);
        setlabelFontSize(
          Math.max(
            0,
            Math.min(customizationObject.labelFontSize, maxSize * 0.2)
          ) // Ensure no negative font sizes
        );
      }
    };

    // Initialize ResizeObserver
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0].contentRect) {
        updateDimensions();
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
      updateDimensions(); // Initial size calculation
    }

    // Cleanup on unmount
    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, [customizationObject.outerRadius, customizationObject.innerRadius]);

  const { total, numberData } = useMemo(
    () => getNumbersAndTotals(Data, valueKeys, true),
    [Data, valueKeys]
  );
  console.log(Data, valueKeys);

  useEffect(() => {
    console.log(Sheetid);
    dispatch(
      setSheetControls({
        Sheetid: Sheetid,
        controls: {
          activeIndex,
          clickedCaption,
        },
      })
    );
  }, [activeIndex, clickedCaption]);

  if (!customizationObject || !Data) {
    return null;
  }

  const isPercentVisible = customizationObject.isPercentVisible;
  const isTotalLabelVisible = customizationObject.isTotalLabelVisible;
  const colorSchemeid = customizationObject.colorSchemeid;
  const isLegendVisible = customizationObject.isLegendVisible;
  const legendAlign = customizationObject.legendAlign;
  const legendVerticalAlign = customizationObject.legendVerticalAlign;
  const legendLayout = customizationObject.legendLayout;
  const COLORS = getColourSchemeByID(colorSchemeid).colors;
  const isLabelVisible = customizationObject.isLabelVisible;
  const labelPosition = customizationObject.labelPosition;
  const labelFontColor = customizationObject.labelFontColor;
  const labelRotate = customizationObject.labelRotate;
  const colorMapping = customizationObject.colorMapping || {};
  const nanoId = nanoid();

  const donut = customizationObject.donut;
  console.log(donut);
  console.log(isTotalLabelVisible);

  const handleClickEvent = (data, index, event, clickType) => {
    console.log("ran");

    const headerItem = groupByKeys.length === 1 && groupByKeys[0].rename;
    if (!getOnClickProperties?.action && !getOnDoubleClickProperties?.action) {
      console.log("actions are not present");
      handleClicked({
        data,
        index,
        event,
        requiredArray: groupByKeys,
        hoverIndex,
        dispatch,
        deleteTemporaryFilters,
        setFiltersToOtherSheets,
        Sheetid,
        clickedCaption,
        setClickedCaption,
        activeIndex,
        setActiveIndex,
        vizType,
        rawRowKeys: rowKeys,
        dataSourceID,
      });
    } else {
      if (getOnClickProperties?.action === "Hierarchy" && groupByKeys[0]) {
        const currentFilterValueWillBe =
          hoverIndex !== undefined ? Data[hoverIndex][`${headerItem}`] : null;
        let isHierarchyLastItemExist, groupIsExpandable;
        // current groupByKeys's index 0 item will be filterItem
        const filterItem = groupByKeys[0] && {
          columnName: groupByKeys[0].columnName,
          dataType: groupByKeys[0].dataType,
          uuid: groupByKeys[0].uuid,
          rename: groupByKeys[0].rename,
          sourceSheetId: Sheetid,
          nanoId: nanoId,
          selectedFilterValues: [currentFilterValueWillBe],
          selectedOperator: "IN",
          filterType: "temporary",
          format: null,
          dataSourceID,
        };
        const foundHierarchy = headerItem
          ? hierarchy.find((item) =>
              item.hierarchyArray.find((arr) => arr.rename === headerItem)
            )
          : null;

        // Check for existing timeout to handle double-click
        if (clickTimeoutState) {
          // If a second click occurs before timeout, clear the previous timer and treat as double-click
          clearTimeout(clickTimeoutState);
          setClickTimeoutState(null);
          if (
            foundHierarchy !== null &&
            foundHierarchy.hierarchyArray &&
            headerItem
          ) {
            isHierarchyLastItemExist =
              foundHierarchy.hierarchyArray[
                foundHierarchy.hierarchyArray.length - 1
              ]["rename"] === headerItem;
          } else {
            isHierarchyLastItemExist = true;
          }
          handleHeirarchy({
            headerId: headerItem,
            foundHierachy: foundHierarchy,
            requiredArray: groupByKeys,
            dispatch: dispatch,
            functionToAddAndUpdate: updateLevel2Properties,
            functionToRemove: removeLevel2Properties,
            Sheetid: Sheetid,
            vizType: vizType,
            functionWillBe: "replaceItemWithNextItem",
          });
          console.log(
            isHierarchyLastItemExist
              ? "filter will be not be added more"
              : dispatchCommonFilters(filterItem, "ADD")
          );
        } else {
          // Otherwise, set a timeout to handle single click
          const timeout = setTimeout(() => {
            console.log(filterItem);
            let removeFilterItem;
            const headerItemIndex =
              foundHierarchy !== null
                ? foundHierarchy.hierarchyArray.findIndex(
                    (item) => item.rename === headerItem
                  )
                : -1; // Use -1 as a default value to indicate "not found"

            console.log(foundHierarchy.hierarchyArray[headerItemIndex - 1]);
            removeFilterItem = filterArray.find(
              (filterItem) =>
                filterItem.filterType === "temporary" &&
                filterItem.uuid ===
                  foundHierarchy.hierarchyArray[headerItemIndex - 1].uuid
            );
            console.log(removeFilterItem);

            // Set a timeout for the single-click action
            handleHeirarchy({
              headerId: headerItem,
              foundHierachy: foundHierarchy,
              requiredArray: groupByKeys,
              dispatch: dispatch,
              functionToAddAndUpdate: updateLevel2Properties,
              functionToRemove: removeLevel2Properties,
              Sheetid: Sheetid,
              vizType: vizType,
              functionWillBe: "replaceItemWithpreviousItem",
            });
            if (removeFilterItem) {
              dispatchCommonFilters(removeFilterItem, "REMOVE");
            }
            setClickTimeoutState(null);
          }, 250); // Set delay (250ms) to differentiate single from double-clicks
          setClickTimeoutState(timeout);
        }
      } else {
        console.log(timer);
        if (timer) {
          //it is a second click
          clearTimeout(timer);
          timer = null;
          console.log("double");
          CalculateAction({
            data,
            index,
            event,
            requiredArray: groupByKeys,
            hoverIndex,
            dispatch,
            deleteTemporaryFilters,
            setFiltersToOtherSheets,
            Sheetid,
            clickedCaption,
            setClickedCaption,
            activeIndex,
            setActiveIndex,
            vizType,
            rawRowKeys: rowKeys,
            actionsProperty: getOnDoubleClickProperties,
            setWorkbookProperty,
            workbookId,
            workbookType,
            navigate,
            dataSourceID,
            sheetsArray,
            roles
          });
        } else {
          timer = setTimeout(() => {
            console.log("single");
            CalculateAction({
              data,
              index,
              event,
              requiredArray: groupByKeys,
              hoverIndex,
              dispatch,
              deleteTemporaryFilters,
              setFiltersToOtherSheets,
              Sheetid,
              clickedCaption,
              setClickedCaption,
              activeIndex,
              setActiveIndex,
              vizType,
              rawRowKeys: rowKeys,
              actionsProperty: getOnClickProperties,
              setWorkbookProperty,
              workbookId,
              workbookType,
              navigate,
              dataSourceID,
              sheetsArray,
              roles
            });
            timer = null;
          }, 300);
          console.log(timer);
        }
        // Log the clickType here will not give correct results because it's asynchronous. Log inside the timeout or callback.
      }
    }
  };

  const data = numberData;
  //  sortData({
  //   transformedData: numberData,
  //   sortProperties,
  //   rawRowKeys: rowKeys,
  //   rawGroupByKeys: groupByKeys,
  //   requiredArray: groupByKeys,
  // });
  // console.log(rowKeys);
  // console.log(groupByKeys);

  console.log(sortProperties);
  
  console.log(numberData);

  const renderCustomizedLabel = ({ cx, cy }) => {
    console.log(donut);

    return (
      <text
        x={cx}
        y={cy}
        fill="black"
        textAnchor="middle"
        dominantBaseline="central"
      >
        {/* total */}

        {formatNumber(total, SufixPrefix)}
      </text>
    );
  };

  return (
    <div ref={containerRef} style={{ width: "100%", height: "100%" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart margin={{ top: 0, bottom: 0 }}>
          <Pie
            data={data}
            //  cx="50%"
            //  cy="50%"
            cx={isLegendVisible ? "50%" : "50%"}
            cy={isLegendVisible ? "50%" : "50%"}
            innerRadius={customizationObject.donut ? innerRadius : 0}
            donut={donut}
            outerRadius={outerRadius}
            fill="#8884d8"
            dataKey={valueKeys.length > 0 && valueKeys[0].responseKey}
            // className="w-[45%]"

            label={donut && isTotalLabelVisible ? renderCustomizedLabel : null}
            labelLine={false}
            endAngle={customizationObject.endAngle}
            paddingAngle={customizationObject.paddingAngle}
            isAnimationActive={isAnimataionOff}
            nameKey={groupByKeys ? groupByKeys?.[0]?.responseKey : null}
            activeIndex={activeIndex.length > 0 ? activeIndex : null}
            activeShape={renderCustomActiveShape}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onClick={(data, index, event) =>
              handleClickEvent(data, index, event)
            }
          >
            {groupByKeys?.[0]?.responseKey &&
              data.map((entry, index) => {
                console.log(groupByKeys?.[0]?.responseKey);
                console.log(entry, index);
                console.log(data);

                const isGray =
                  activeIndex.length > 0 && !activeIndex.includes(index);
                console.log(isGray);

                return (
                  <Cell
                    key={`cell-${index}`}
                    fill={
                      isGray
                        ? adjustOpacity(
                            colorMapping[entry[groupByKeys?.[0].responseKey]] ||
                              COLORS[index % COLORS.length]
                          )
                        : colorMapping[entry[groupByKeys?.[0]?.responseKey]] ||
                          COLORS[index % COLORS.length]
                    }
                  />
                );
              })}

            {isLabelVisible && (
              <LabelList
                data={data}
                dataKey={valueKeys.length > 0 && valueKeys[0]?.responseKey}
                position={labelPosition?.value || null}
                fill={labelFontColor}
                stroke={labelFontColor}
                fontWeight="100"
                fontSize={customizationObject.labelFontSize}
                angle={labelRotate}
                total={total}
                formatter={(value, entry) => {
                  const percentage =
                    total > 0 ? ((value / total) * 100).toFixed(1) : "0";
                  const formattedValue = isPercentVisible
                    ? `${formatNumber(value, SufixPrefix)} (${percentage}%)`
                    : formatNumber(value, SufixPrefix);
                  return formattedValue;
                }}
                offset={labelOffset}
              />
            )}
          </Pie>

          {isLegendVisible && (
            <Legend
              align={legendAlign.value}
              verticalAlign={legendVerticalAlign.value}
              layout={legendLayout.value}
              content={
                <CustomLegend
                  {...{
                    align: legendAlign.value,
                    verticalAlign: legendVerticalAlign.value,
                    layout: legendLayout.value,
                    containerHeight,
                    containerWidth,
                    valueKeys,
                  }}
                />
              }
              // content={<p className="w-full flex items-start">Mohit1</p>}
            />
          )}

          <Tooltip
            content={
              <CustomTooltip
                tooltipKeys={toolTipKeys}
                // toolTipKeys={toolTipKeys}
                SufixPrefix={SufixPrefix}
                colorSchemeid={colorSchemeid}
                total={total}
                cursor={false}
                hoverIndex={hoverIndex}
                chartType={"pie"}
                rowKeys={groupByKeys}
                valueKeys={valueKeys}
              />
            }
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReduxPieComp;
